<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Popup"
    }
</script>

<style scoped>

</style>